const {
  pick
} = require('lodash');
const {
  evaluateSources
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate joinTableDiffBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const picked = pick(source, ['localColumn', 'localValues', 'relatedColumn', 'relatedOldValues', 'relatedNewValues']);
  const {
    localColumn,
    localValues = [],
    relatedColumn,
    relatedOldValues = [],
    relatedNewValues = []
  } = await evaluateSources(picked, content, parentContentPath, transientContext, nativeFunctions);
  const additions = relatedNewValues.filter(item => !relatedOldValues.includes(item));
  const removals = relatedOldValues.filter(item => !relatedNewValues.includes(item));
  const results = {
    additions: [],
    removals: []
  };
  for (let localIndex = 0; localIndex < localValues.length; localIndex += 1) {
    const localValue = localValues[localIndex];
    for (let additionsIndex = 0; additionsIndex < additions.length; additionsIndex += 1) {
      const item = {};
      item[localColumn] = localValue;
      item[relatedColumn] = additions[additionsIndex];
      results.additions.push(item);
    }
    for (let removalsIndex = 0; removalsIndex < removals.length; removalsIndex += 1) {
      const item = {};
      item[localColumn] = localValue;
      item[relatedColumn] = removals[removalsIndex];
      results.removals.push(item);
    }
  }
  return results;
};
module.exports = {
  evaluate
};